$(function () {
  const $year = $("#user_form_birthday_1i");
  const $month = $("#user_form_birthday_2i");
  const $day = $("#user_form_birthday_3i");
  const default_date = "1";

  $("#user_form_birthday_1i, #user_form_birthday_2i").on("change", function () {
    const year = parseInt($year.val());
    const month = parseInt($month.val());
    const day = parseInt($day.val());
    const days = new Date(year, month, 0).getDate();
    changeDayOptions(days);
    if (day > days) {
      $day.val(default_date);
    }
  });
});

const changeDayOptions = function(days_in_month) {
  [29, 30, 31].forEach(e => {
    if (e > days_in_month) {
      $('#user_form_birthday_3i option[value="'+ e +'"]').hide();
    } else {
      $('#user_form_birthday_3i option[value="'+ e +'"]').show();
    }
  })
}
